/**
 * The drivers' threads, as the desk reads and writes them.
 *
 * The types are the API's own, from the generated schema, like every `api.ts` here.
 */

import { request, type Schema } from '@taxi/api-client';

/** One line of a thread. */
export type Message = Schema<'MessageView'>;

/** One driver's thread as the desk lists it: who, the last word, what is unread. */
export type Thread = Schema<'ThreadView'>;

/**
 * The ready phrases the office can send with one click, by code.
 *
 * The server refuses any other code, and the words for each are in the shared bundle under
 * `driverMessages.office`, so the phone shows the same phrase in its own language.
 */
export const OFFICE_PRESETS = [
  'ok',
  'call_office',
  'wait_there',
  'passenger_coming',
  'go_to_rank',
  'hurry',
] as const;

export const messagesApi = {
  threads: () => request<Thread[]>('/api/dispatch/messages'),

  thread: (driverId: string) => request<Message[]>(`/api/dispatch/messages/${driverId}`),

  send: (driverId: string, draft: { code: string | null; body: string | null }) =>
    request<Message>(`/api/dispatch/messages/${driverId}`, { method: 'POST', body: draft }),

  read: (driverId: string) =>
    request<void>(`/api/dispatch/messages/${driverId}/read`, { method: 'POST' }),
};
